/**
 * This file contains everything needed to create the model viewer HTML element to be appended to the DOM
 */

const whiteImage =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=\n';

/**
 * generate the inner HTML for the model viewer component. This does include an
 * invisible 'ar-button' to prevent the model viewer from creating the obnoxious
 * floating default.
 */
const createModelViewerHtml = () => `
<div slot="poster" style='opacity: 0'></div> 
<div slot="progress-bar" style='opacity: 0'></div>
<button slot="ar-button" style='opacity: 0'></button>
`;

export const createModelViewerElement = () => {
    // the included declarations cast to a type which does not include standard HTML node types so we need to cast back!
    const modelViewer = document.createElement('model-viewer');

    // Even though we override these later, they're used internally by model-viewer as an init sanity check.
    // Do not omit these!
    modelViewer.src = '';
    modelViewer.arPlacement = 'floor';
    modelViewer.alt = 'AR Scene';
    modelViewer.arModes = 'scene-viewer webxr quick-look';
    modelViewer.environmentImage = 'neutral';
    modelViewer.autoRotate = true;
    modelViewer.interactionPrompt = 'auto';
    modelViewer.cameraControls = true;
    modelViewer.setAttribute(
        'style',
        'background-color: unset; width: 100%; height: 100%; display: none;',
    );
    modelViewer.setAttribute('data-testid', 'model-viewer-element');
    modelViewer.cameraOrbit = '-45deg 75deg 105%';
    modelViewer.ar = true;

    // prevent model from automatically loading
    modelViewer.setAttribute('reveal', 'manual');

    // show a white image as a "poster" (typically a low resolution render used for preloading)
    modelViewer.poster = whiteImage;
    modelViewer.setAttribute('poster', whiteImage);

    modelViewer.innerHTML = createModelViewerHtml();

    return modelViewer;
};
